<template>
  <div class="header-sp">
    <img
      src="@/assets/geeksalon.png"
      height="15px"
      class="logo"
      @click="toHome"
    />
  </div>
</template>

<script>
export default {
  name: "SpHeader",
  methods: {
    toHome() {
      this.$router.push("/")
    },
  },
}
</script>

<style lang="scss">
.header-sp {
  position: relative;
  background: transparent url("./images/minproiPhone.png") 0% 0% no-repeat
    padding-box;
  background-size: cover;
  padding-top: 64%;

  @font-face {
    font-family: "GenJyuuGothic";
    src: url("./fonts/GenJyuuGothicX.woff");
  }

  .logo {
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translate(-50%, 0);
    cursor: pointer;
  }
}
</style>
